import React, { createContext, useContext, useState } from "react";
import { X } from "lucide-react";

import { useUserContext } from "../UserProvider";

const UpgradePlanContext = createContext();

export const useUpgradePlan = () => {
  const context = useContext(UpgradePlanContext)
  if (context === undefined) {
    throw new Error('useUpgradePlan must be used within a UpgradePlanProvider')
  }
  return context
}

export const UpgradePlanProvider = ({ children }) => {
  const { userData } = useUserContext()
  const [isOpen, setIsOpen] = useState(false)
  const [onClose, setOnClose] = useState(() => { })

  const showPlanUpgrade = (callback) => {
    setIsOpen(true)
    setOnClose(() => {
      return () => setIsOpen(false) && callback && callback()
    })
  }

  return (
    <UpgradePlanContext.Provider value={{ showPlanUpgrade }}>
      <>
        {children}
        {isOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-6 rounded-lg max-w-md">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-bold">Upgrade Your Plan</h2>
                <button onClick={onClose}>
                  <X size={20} />
                </button>
              </div>
              <>
                <p className="mb-4 text-sm">
                  You've reached the maximum number of publishers for your current plan.
                  Upgrade to our Pro plan to add more!
                </p>
                <div className="mb-4">
                  <h3 className="font-semibold text-sm">
                    Current Plan: {userData?.plan?.name}
                  </h3>
                  <ul className="list-disc list-inside text-sm">
                    <li>Up to {userData?.plan?.publisher_limit || 2} publishers</li>
                    <li>Basic AI analysis</li>
                    <li>7-day history</li>
                  </ul>
                </div>
                <div className="mb-4">
                  <h3 className="font-semibold text-sm">Pro Plan</h3>
                  <ul className="list-disc list-inside text-sm">
                    <li>Unlimited publishers</li>
                    <li>Advanced AI insights</li>
                    <li>30-day history</li>
                    <li>Priority support</li>
                  </ul>
                </div>
                <button className="bg-blue-500 text-white px-4 py-2 rounded w-full text-sm">
                  Upgrade to Pro
                </button>
              </>
            </div>
          </div>
        )}
      </>
    </UpgradePlanContext.Provider>
  );
};

export default UpgradePlanProvider;
